/**
 * useChannelMemberships — B-2026-0091
 *
 * Fetches all channel memberships for the current authenticated user via
 * GET /auth/me/channel-memberships.  Provides each channel the user belongs
 * to along with their role in that channel (owner / coach / athlete / viewer).
 *
 * Used by ChannelSwitcher to build the context-switcher dropdown in the top bar.
 */

import { useQuery } from '@tanstack/react-query';
import { getMyChannelMemberships } from '@/services/channelApi';
import { useAuth } from '@/contexts/AuthContext';
import type { ChannelMembershipSummary } from '@/types/channel';

export function useChannelMemberships() {
  const { user } = useAuth();
  return useQuery<ChannelMembershipSummary[]>({
    queryKey: ['channel-memberships', user?.id],
    queryFn: getMyChannelMemberships,
    enabled: !!user?.id,
    staleTime: 60_000, // 1 min — memberships don't change often
  });
}
